export const app = {
  connectToYourWhatsappNumber: 'Povežite se sa svojim WhatsApp brojem',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Povežite svog WhatsApp Bota sa svojim WhatsApp brojem',
  connect: 'Poveži',
};

